export default __webpack_public_path__ + "static/media/Hawksight.7ac881f9.jpg";